document.addEventListener("DOMContentLoaded", () => {
    const updateInputCheckboxes = () => {
        document.querySelectorAll("input[type='checkbox']").forEach(checkbox => {
            if (!checkbox.hasAttribute("aria-checked")) {
                checkbox.setAttribute("aria-checked", checkbox.checked ? "true" : "false");
            }
            checkbox.addEventListener("change", () => {
                checkbox.setAttribute("aria-checked", checkbox.checked ? "true" : "false");
            });
        });
    };

    const updateButtonCheckboxesOnLoad = () => {
        document.querySelectorAll(".boost-pfs-filter-button[role='checkbox']").forEach(button => {
            if (!button.hasAttribute("aria-checked")) {
                button.setAttribute("aria-checked", "false");
            }
            button.addEventListener("click", () => {
                setTimeout(updateButtonCheckboxAriaLabels, 1500);
            });
        });
    };

    const updateButtonCheckboxAriaLabels = () => {
        document.querySelectorAll(".boost-pfs-filter-button[role='checkbox']").forEach(button => {
            if (!button.hasAttribute("aria-checked")) {
                button.setAttribute("aria-checked", "false");
            }
        });
    };

    updateInputCheckboxes();

    setTimeout(updateButtonCheckboxesOnLoad, 1500);
});
